let stage = '';

export const initEnv = (stageValue: string) => {
  stage = stageValue;
  console.log('initEnv', stageValue);
};

export const resolveCookieDomain = (hostname: string): string | undefined => {
  const normalized = hostname.toLowerCase();

  if (normalized === 'gbase-ai.com' || normalized.endsWith('.gbase-ai.com')) {
    return '.gbase-ai.com';
  }
  if (normalized === 'gbase.ai' || normalized.endsWith('.gbase.ai')) {
    return '.gbase.ai';
  }
  if (normalized === 'gptbase.ai' || normalized.endsWith('.gptbase.ai')) {
    return '.gptbase.ai';
  }

  return undefined;
};

export const isSentryEligibleHostname = (hostname: string): boolean => resolveCookieDomain(hostname) !== undefined;

export const cookieConfig = {
  // 区分正式环境和测试环境、本地部署环境、本地开发环境
  get TOKEN_PREFIX() {
    switch (stage) {
      case 'development':
        return 'DEV_';
      case 'pre':
        return 'PRE_';
      case 'local_deploy':
        return 'LOCAL_';
      case 'staging':
        return 'STAGING_';
      case 'onprem-main':
        return 'ONPREM_MAIN_';
      case 'production':
      default: {
        return '';
      }
    }
  },
  // cookie domain
  get COOKIE_DOMAIN() {
    // support-mirror：站点迁移并存期 gbase.ai/support/ 镜像构建，cookie 行为需与生产一致
    return ['pre', 'production', 'staging', 'onprem-main', 'support-mirror'].includes(stage)
      ? resolveCookieDomain(window.location.hostname)
      : '';
  },
};

// token 值 `toekn_type + access_token`
export const KEY_MYGPT_TOKEN = () => cookieConfig.TOKEN_PREFIX + 'MY_GPT_TOKEN';

// refrsh token 值
export const KEY_MYGPT_REFRESH_TOKEN = () => cookieConfig.TOKEN_PREFIX + 'KEY_MYGPT_REFRESH_TOKEN';

// token 过期时间
export const KEY_MYGPT_TOKEN_EXPIRESIN = () => cookieConfig.TOKEN_PREFIX + 'MY_GPT_TOKEN_EXPIRESIN';

// chat 对话历史
export const KEY_MYGPT_COMPLETIONS = 'MY_GPT_COMPLETIONS';

// 存储登录前的pathName
export const KEY_MYGPT_PATH_NAME = 'MY_GPT_PATH_NAME';

// 多语言
export const KEY_TRANSLATE_LANGUAGE = 'MY_GPT_LANGUAGE';

// 用户昵称
export const KEY_USER_NICKNAME = 'MY_GPT_USER_NICKNAME';

// 用户指纹
export const KEY_USER_FINGERPRINT = 'MY_GPT_USER_FINGERPRINT';

// Realtime 声明同意记录（按用户标识存储）
export const KEY_REALTIME_CONSENT = 'MY_GPT_REALTIME_CONSENT';

// Chat 送信前声明同意记录（按用户标识存储）
export const KEY_CHAT_CONSENT = 'MY_GPT_CHAT_CONSENT';

// Mixpanel Token
export const MIXPANEL_TOKEN = '1c7ce9876de96d036ad15d8c4e55c5b1';
export const COOKIE_KEY_MIXPANEL = `mp_${MIXPANEL_TOKEN}_mixpanel`;

// Widget Message Key
export const IFRAME_MESSAGE_OPEN = 'gptBaseWidgetOpened';
export const IFRAME_MESSAGE_CLOSE = 'gptBaseWidgetClose';

// Master Size
export const MASTER_SIZE = 'https://cs.gbase.ai';

// Question Type
export const QUESTION_TYPE = {
  SIMPLE: 'simple',
  DETAIL: 'detail',
};

//AI STATUS
export const AI_STATUS = {
  INIT: 'init',
  READY: 'ready',
};

// 测试环境标识：dev / pre / staging 默认显示调试工具
// 注意：必须用 import.meta.env.VITE_STAGE（编译时注入），不能用上面的 `stage` 变量
// 因为 `stage` 在 initEnv() 运行时才赋值，模块加载期间这里立即求值会拿到空字符串
export const PRODUCTION_STAGE_DEV = ['development', 'pre', 'staging'].includes(import.meta.env.VITE_STAGE);

// widget footerBrand default value
export const WIDGET_FOOTER_DEFAULT_TEXT = 'Powered by GBase';

// Language List
export const LANGUAGE_OPTIONS_LIST = {
  en: ' English',
  'zh-Hans': '中文',
  ja: ' 日本語',
  ko: ' 한국어',
  es: ' Español',
  fr: ' Français',
  de: ' Deutsch',
  ru: ' Русский',
  pt: ' Português',
  it: ' Italiano',
  nl: ' Nederlands',
  pl: ' Polski',
  sv: ' Svenska',
  da: ' Dansk',
  no: ' Norsk',
  fi: ' Suomi',
  tr: ' Türkçe',
  ar: ' العربية',
  he: ' עברית',
  hi: ' हिन्दी',
  id: ' Bahasa Indonesia',
  ms: ' Bahasa Melayu',
  th: ' ไทย',
  vi: ' Tiếng Việt',
  el: ' Ελληνικά',
  hu: ' Magyar',
  cs: ' Čeština',
  sk: ' Slovenčina',
  uk: ' Українська',
  bg: ' Български',
  ro: ' Română',
  hr: ' Hrvatski',
  sr: ' Српски',
  sl: ' Slovenščina',
  et: ' Eesti',
  lv: ' Latviešu',
  lt: ' Lietuvių',
};

// 保存用户的基本信息
export const USER_INFO = cookieConfig.TOKEN_PREFIX + 'USER_INFO';
